import { Injectable } from '@angular/core';
import featureFlags from 'src/assets/data/feature-flags.json';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  get fakeFlags() {
    return featureFlags.useFakeValidations;
  }
}
